import IUserFilter from "interfaces/IUserFilter";
import { UserQuickFilter } from "interfaces/models/UserQuickFilter";

const initialUserFilter = () : IUserFilter => ({
  group: undefined,
  userTypes: [],
  quickFilter: UserQuickFilter.All,
  searchText: ""
});

export { initialUserFilter };
